import clsx from "clsx";
import React, { FunctionComponent } from "react";

import VergeLogo from "@ui/components/brand/theverge/VergeLogo";

import * as styles from "./NavigationDrawerBackground.css";

interface Props {
  className?: string;
}

const NavigationDrawerBackground: FunctionComponent<Props> = ({
  className,
}) => {
  return (
    <div className={clsx(styles.backgroundImage, className)}>
      <VergeLogo />
    </div>
  );
};

export default NavigationDrawerBackground;
